import React from "react";
import "./loginForm.scss";
import Logo from "../../assets/Logo-mundo-blanco.svg";
import CustomForm from "@sistemas.mundo/custom-form";
import { Grid, Typography } from "@mui/material";
import { useUsuario } from "../../context/usuarioContext";

const LoginForm = ({ setcambioDatos }) => {
  //querys
  const { loginUsuario } = useUsuario();

  const onSubmit = (data) => {
    loginUsuario(data);
  };

  const camposFormulario = () => {
    return [
      {
        title: "",
        elements: [
          {
            name: "user",
            label: "RUT",
            placeholder: "12345678-9",
            value: null,
            type: "rut",
            required: true,
            onChange: null,
            customValidation: null,
            customFormat: null,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
          {
            name: "pass",
            label: "Contraseña",
            placeholder: "Contraseña",
            value: null,
            type: "password",
            required: true,
            onChange: null,
            customValidation: null,
            customFormat: null,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
        ],
      },
    ];
  };

  return (
    <div className="login-container">
      <div className="logo__form">
        <Logo className="logo__image__form" width={"100%"} height={"100%"} />
      </div>

      <div className="welcome_form">
        <Typography variant="h4" className="titulo__form">
          Bienvenido a tu
        </Typography>
        <Typography variant="h4" className="subtitulo__form">
          Sucursal Virtual
        </Typography>
      </div>
      <div className="login-form">
        <div
          style={{
            marginLeft: "66px",
            marginRight: "66px",
            marginTop: "1rem",
            marginBottom: "2rem",
          }}
        >
          <CustomForm
            formId="formulario_login1"
            campos={camposFormulario()}
            showClearForm={false}
            onSubmit={onSubmit}
            submitButtonText={"Ingresar"}
            tooltipSubmitBtn={"Ingresar"}
            submitButtonPosition="center"
            fullButtonSubmitWidth={true}
            resetCamposOnSubmit={false}
          />
          <Grid container>
            <Grid
              item
              xs={12}
              sx={{
                display: "grid",
                placeItems: "center",
                marginTop: "2rem",
                marginBottom: "0.8rem",
              }}
            >
              <a
                onClick={() => setcambioDatos(true)}
                style={{
                  color: "#00657d",
                  fontSize: "13px",
                  textAlign: "center",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                Olvidé mis datos de acceso
              </a>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
